<template>
    <v-card flat max-width="950px" class="mx-auto transparent">

        <v-card outlined  style="border-top-left-radius:0; border-top-right-radius:0; border-top:none">
			<Message />

			<div class="px-4 pt-3 pb-6 px-sm-10 pt-sm-7 pb-sm-12">
				<div class="headline font-weight-medium accent--text text-center">ONLINE SHOP</div>
				<div class="subtitle-1 font-weight-medium text-center">Get your teen started on their path today!</div>

				<div class="mt-6 text-center">
					<v-btn depressed class="primary white--text" href="http://3stepstocollege.com">Back to site</v-btn>
				</div>

				<!-- MONTHLY SUBSCRIPTION -->
				<div class="text-center mb-10" style="margin-top:70px">
					<span class="grey lighten-2 primary--text px-4 py-3 font-weight-medium" style="border-radius:20px">3 STEPS MONTHLY SUBSCRIPTION PROGRAM</span>
				</div>
				<div class="d-flex justify-center">
					<div class="ml-6 ml-sm-0">
						<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goSubscription">
							<v-img :src="require('@/assets/products/subscription.png')"></v-img>
						</v-card>
						<div class="ml-2 mt-3">
							<div class="font-weight-medium ml-1">Monthly Subscription</div>
							<div class="title primary--text mt-n1 ml-1">$12.99 USD</div>
							<v-btn rounded small class="accent mt-1" depressed @click="goSubscription">
								Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
							</v-btn>
						</div>
					</div>
				</div>

				<v-divider class="my-12"></v-divider>

				<!-- LIVESTREAM -->
				<div class="text-center mb-10" style="margin-top:70px">
					<span class="grey lighten-2 primary--text px-4 py-3 font-weight-medium" style="border-radius:20px">THE 3 STEPS LIVESTREAM PROGRAM</span>
				</div>
				<div class="d-flex justify-center">
					<div class="ml-6 ml-sm-0">
						<v-card flat class="transparent" width="200px" style="border-radius:20px">
							<v-img :src="require('@/assets/products/livestream.png')"></v-img>
						</v-card>
						<div class="ml-2 mt-3">
							<div class="font-weight-medium ml-1">3 Steps Livestream</div>
							<div class="subtitle-1 font-weight-medium accent--text mt-n1 ml-1">Coming Soon!</div>
							<!-- <v-btn rounded small class="accent mt-1" depressed disabled>
								Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
							</v-btn> -->
						</div>
					</div>
				</div>

				<v-divider class="my-12"></v-divider>

				<!-- PROGRAM -->
				<div class="text-center mt-12 mb-10">
					<span class="grey lighten-2 primary--text px-4 py-3 font-weight-medium" style="border-radius:20px">3 STEPS TO COLLEGE PROGRAM</span>
				</div>
				<div class="d-flex justify-center">
					<div class="d-flex flex-column flex-sm-row">
						<div class="ml-6 ml-sm-0">
							<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goProgramApplication">
								<v-img :src="require('@/assets/products/program-application.png')"></v-img>
							</v-card>
							<div class="ml-2 mt-3">
								<div class="font-weight-medium ml-1">Program Application</div>
								<div class="title primary--text mt-n1 ml-1">$65 USD</div>
								<v-btn rounded small class="accent mt-1" depressed @click="goProgramApplication">
									Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
								</v-btn>
							</div>
						</div>
						<div class="ml-6 ml-sm-12 mt-8 mt-sm-0" style="opacity:.5">
							<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goProgramModule1">
								<v-img :src="require('@/assets/products/program-module1.png')"></v-img>
							</v-card>
							<div class="ml-2 mt-3">
								<div class="font-weight-medium ml-1">Program Module 1</div>
								<div class="title primary--text mt-n1 ml-1">$1,000 USD</div>
								<v-btn rounded small class="accent mt-1" depressed @click="goProgramModule1">
									Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
								</v-btn>
							</div>
						</div>
						<div class="ml-6 ml-sm-12 mt-8 mt-sm-0" style="opacity:.5">
							<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goProgramModule2">
								<v-img :src="require('@/assets/products/program-module2.png')"></v-img>
							</v-card>
							<div class="ml-2 mt-3">
								<div class="font-weight-medium ml-1">Program Module 2</div>
								<div class="title primary--text mt-n1 ml-1">$1,000 USD</div>
								<v-btn rounded small class="accent mt-1" depressed @click="goProgramModule2">
									Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
								</v-btn>
							</div>
						</div>
					</div>
				</div>
				
				<v-divider class="my-12"></v-divider>

				<!-- SUMMERCAMP -->
				<div class="text-center mt-12 mb-10">
					<span class="grey lighten-2 primary--text px-4 py-3 font-weight-medium" style="border-radius:20px">3 STEPS SUMMERCAMP</span>
				</div>
				<div class="d-flex justify-center">
					<div class="d-flex flex-column flex-sm-row">
						<div class="ml-6 ml-sm-0">
							<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goSummercampApplication">
								<v-img :src="require('@/assets/products/summercamp-application.png')"></v-img>
							</v-card>
							<div class="ml-2 mt-3">
								<div class="font-weight-medium ml-1">Summercamp Application</div>
								<div class="title primary--text mt-n1 ml-1">$65 USD</div>
								<v-btn rounded small class="accent mt-1" depressed @click="goSummercampApplication">
									Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
								</v-btn>
							</div>
						</div>
						<div class="ml-6 ml-sm-12 mt-8 mt-sm-0" style="opacity:.5">
							<v-card flat class="transparent" width="200px" style="border-radius:20px" @click="goSummercamp">
								<v-img :src="require('@/assets/products/summercamp.png')"></v-img>
							</v-card>
							<div class="ml-2 mt-3">
								<div class="font-weight-medium ml-1">Summercamp 2021</div>
								<div class="title primary--text mt-n1 ml-1">$4,750 USD</div>
								<v-btn rounded small class="accent mt-1" depressed @click="goSummercamp">
									Enroll <v-icon color="white" small right>fa fa-angle-right</v-icon>
								</v-btn>
							</div>
						</div>
					</div>
				</div>
			</div>
        </v-card>
    </v-card>
</template>

<script>
import Cart from  '@/firebase/cart'
import Message from '@/components/cart/Message'

export default {
  	data: () => ({
		now: false
	}),
	components: {
        Message
    },
	mounted() {
		this.$gtm.trackView('Cart', '/cart');
	},
  	methods: {
		goSubscription() {
			this.$router.push('/subscription');
		},
		goLivestream() {
			this.$router.push('/cart/livestream');
		},
		goProgramApplication() {
			this.$router.push('/cart/program-application');
		},
		goProgramModule1() {
			//this.$router.push('/cart/program-module1');
		},
		goProgramModule2() {
			//this.$router.push('/cart/program-module2');
		},
		goSummercampApplication() {
			this.$router.push('/cart/summercamp-application');
		},
		goSummercamp() {
			//this.$router.push('/cart/summercamp');
		}
  	}
}
</script>